import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import speed15SecondIconGray from "@/assets/svgs/15sIconGray.svg";
import speed15SecondIconWhite from "@/assets/svgs/15sIconWhite.svg";
import speed30SecondIconGray from "@/assets/svgs/30sIconGray.svg";
import speed30SecondIconWhite from "@/assets/svgs/30sIconWhite.svg";
import adminButton from "@/assets/svgs/adminButton.svg";
import authIcon from "@/assets/svgs/authIcon.svg";
import backArrowIcon from "@/assets/svgs/backArrowIcon.svg";
import bigRedSplash from "@/assets/svgs/bigRedSplashOptimized.svg";
import bookMusicIconGray from "@/assets/svgs/bookMusicIconGray.svg";
import bookMusicIconPink from "@/assets/svgs/bookMusicIconPink.svg";
import copyIcon from "@/assets/svgs/copyIcon.svg";
import createJam from "@/assets/svgs/createJam.svg";
import crossBordered from "@/assets/svgs/crossBorderd.svg";
import crossIcon from "@/assets/svgs/CrossIcon.svg";
import disk2Icon from "@/assets/svgs/disk2Icon.svg";
import diskIcon from "@/assets/svgs/diskIcon.svg";
import editPenIcon from "@/assets/svgs/editPenIcon.svg";
import eyeIcon from "@/assets/svgs/eyeIcon.svg";
import fifteenSecIcon from "@/assets/svgs/FifteenSecIcon.svg";
import getHelp from "@/assets/svgs/getHelp.svg";
import groupIcon from "@/assets/svgs/groupIcon.svg";
import homeIcon from "@/assets/svgs/homeIcon.svg";
import jamDeckIcon from "@/assets/svgs/jamDeckIcon.svg";
import jamIcon from "@/assets/svgs/jamIcon.svg";
import jindoProfileLogo from "@/assets/svgs/jindoProfileLogo.svg";
import jindoWhiteLogo from "@/assets/svgs/JindoWhiteLogo.svg";
import jindoWhiteWithSplash from "@/assets/svgs/jindoWhiteWithSplash.svg";
import lockIcon from "@/assets/svgs/lockIcon.svg";
import manageSubscription from "@/assets/svgs/ManageSugbscription.svg";
import messageIcon from "@/assets/svgs/messageIcon.svg";
import minusIcon from "@/assets/svgs/MinusIcon.svg";
import ohNoIcon from "@/assets/svgs/onNoIcon.svg";
import pauseIcon from "@/assets/svgs/PauseIcon.svg";
import playersBlack from "@/assets/svgs/playersBlack.svg";
import playersIconBlack from "@/assets/svgs/playersIconBlack.svg";
import playersIconGray from "@/assets/svgs/playersIconGray.svg";
import playersJoinedIcon from "@/assets/svgs/PlayersJoinedIcon.svg";
import playIcon from "@/assets/svgs/PlayIcon.svg";
import playlistIcon from "@/assets/svgs/playlistIcon.svg";
import plusIcon from "@/assets/svgs/PlusIcon.svg";
import prizeGrayIcon from "@/assets/svgs/prizeGrayIcon.svg";
import prizePinkIcon from "@/assets/svgs/prizePinkIcon.svg";
import prizeTransparentBlack from "@/assets/svgs/prizeTransparentBlack.svg";
import quitIcon from "@/assets/svgs/quitIcon.svg";
import settingIcon from "@/assets/svgs/settingIcon.svg";
import settings3Wheel from "@/assets/svgs/settings3Wheel.svg";
import shareIcon from "@/assets/svgs/shareIcon.svg";
import songIcon from "@/assets/svgs/songIcon.svg";
import songsUploadIcon from "@/assets/svgs/songsUploadIcon.svg";
import thirtySecIcon from "@/assets/svgs/ThirtySecIcon.svg";
import timeIcon from "@/assets/svgs/timeIcon.svg";
import userIcon from "@/assets/svgs/userIcon.svg";
import winnerCelebration from "@/assets/svgs/winnerCelebration.svg";
import yellowSplash from "@/assets/svgs/yellowSplash.svg";
import type { ComponentProps } from "react";
interface IconProps extends Omit<ComponentProps<typeof Image>, "src" | "alt" | "width" | "height"> {
  width?: number | "auto";
  height?: number | "auto";
  onClick?: () => void;
  iconFill?: string;
}

// Helper function to create icon components
const createIconComponent = (svgImport: any, defaultWidth: number | "auto" = "auto", defaultHeight: number | "auto" = "auto") => {
  const IconComponent = t0 => {
    const $ = _c(18);
    let className;
    let onClick;
    let props;
    let t1;
    let t2;
    if ($[0] !== t0) {
      const {
        width: t3,
        height: t4,
        iconFill,
        onClick: t5,
        className: t6,
        ...t7
      } = t0;
      t1 = t3;
      t2 = t4;
      onClick = t5;
      className = t6;
      props = t7;
      $[0] = t0;
      $[1] = className;
      $[2] = onClick;
      $[3] = props;
      $[4] = t1;
      $[5] = t2;
    } else {
      className = $[1];
      onClick = $[2];
      props = $[3];
      t1 = $[4];
      t2 = $[5];
    }
    const width = t1 === undefined ? defaultWidth : t1;
    const height = t2 === undefined ? defaultHeight : t2;
    const imageWidth = width === "auto" ? undefined : width;
    const imageHeight = height === "auto" ? undefined : height;
    const t3 = height === "auto" ? "auto" : `${height}px !important`;
    const t4 = width === "auto" ? "auto" : `${width}px !important`;
    const t5 = width === "auto" ? "auto" : `${width}px !important`;
    const t6 = height === "auto" ? "auto" : `${height}px !important`;
    let t7;
    if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5 || $[9] !== t6) {
      t7 = {
        maxHeight: t3,
        maxWidth: t4,
        minWidth: t5,
        minHeight: t6
      };
      $[6] = t3;
      $[7] = t4;
      $[8] = t5;
      $[9] = t6;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    let t8;
    if ($[11] !== className || $[12] !== imageHeight || $[13] !== imageWidth || $[14] !== onClick || $[15] !== props || $[16] !== t7) {
      t8 = <Image src={svgImport} alt="" width={imageWidth} height={imageHeight} onClick={onClick} className={className} style={t7} {...props} />;
      $[11] = className;
      $[12] = imageHeight;
      $[13] = imageWidth;
      $[14] = onClick;
      $[15] = props;
      $[16] = t7;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    return t8;
  };
  IconComponent.displayName = `Icon(${svgImport.src || "unknown"})`;
  return IconComponent;
};

// Create all icon components using imported SVG assets
export const PlayersJoinedIcon = createIconComponent(playersJoinedIcon);
export const TimeIcon = createIconComponent(timeIcon);
export const Speed15SecondIconGray = createIconComponent(speed15SecondIconGray);
export const Speed15SecondIconWhite = createIconComponent(speed15SecondIconWhite);
export const Speed30SecondIconGray = createIconComponent(speed30SecondIconGray);
export const Speed30SecondIconWhite = createIconComponent(speed30SecondIconWhite);
export const JindoWhiteWithSplashIcon = createIconComponent(jindoWhiteWithSplash);
export const BigRedSplashIcon = createIconComponent(bigRedSplash);
export const QuitIcon = createIconComponent(quitIcon);
export const LockIcon = createIconComponent(lockIcon);
export const CopyIcon = createIconComponent(copyIcon);
export const JindoProfileIcon = createIconComponent(jindoProfileLogo);
export const YellowSplashIcon = createIconComponent(yellowSplash);
export const PrizePinkIcon = createIconComponent(prizePinkIcon);
export const PrizeGrayIcon = createIconComponent(prizeGrayIcon);
export const PlayersBlackIcon = createIconComponent(playersBlack);
export const PrizeTransparentBlackIcon = createIconComponent(prizeTransparentBlack);
export const BookMusicIconGray = createIconComponent(bookMusicIconGray);
export const BookMusicIconPink = createIconComponent(bookMusicIconPink);
export const JamDeckIcon = createIconComponent(jamDeckIcon);
export const DiskIcon = createIconComponent(diskIcon);
export const GroupIcon = createIconComponent(groupIcon);
export const Settings3WheelIcon = createIconComponent(settings3Wheel);
export const ShareIcon = createIconComponent(shareIcon);
export const CreateJamIcon = createIconComponent(createJam);
export const UserIcon = createIconComponent(userIcon);
export const GetHelpIcon = createIconComponent(getHelp);
export const ManageSubscriptionIcon = createIconComponent(manageSubscription);
export const AdminIcon = createIconComponent(adminButton);
export const BackArrowIcon = createIconComponent(backArrowIcon);
export const JindoWhiteLogo = createIconComponent(jindoWhiteLogo);
export const PauseIcon = createIconComponent(pauseIcon);
export const PlayIcon = createIconComponent(playIcon);
export const MinusIcon = createIconComponent(minusIcon);
export const PlusIcon = createIconComponent(plusIcon);
export const FifteenSecIcon = createIconComponent(fifteenSecIcon);
export const ThirtySecIcon = createIconComponent(thirtySecIcon);
export const CrossIcon = createIconComponent(crossIcon);
export const HomeIcon = createIconComponent(homeIcon);
export const PlaylistIcon = createIconComponent(playlistIcon);
export const SettingsIcon = createIconComponent(settingIcon);
export const JamIcon = createIconComponent(jamIcon);
export const EyeIcon = createIconComponent(eyeIcon);
export const AuthIcon = createIconComponent(authIcon);
export const Disk2Icon = createIconComponent(disk2Icon);
export const OhNoIcon = createIconComponent(ohNoIcon);
export const SongsUploadIcon = createIconComponent(songsUploadIcon);
export const EditPenIcon = createIconComponent(editPenIcon);
export const SongsIcon = createIconComponent(songIcon);
export const CrossBorderedIcon = createIconComponent(crossBordered);
export const WinnerCelebrationIcon = createIconComponent(winnerCelebration);
export const MessageIcon = createIconComponent(messageIcon);
export const PlayersIconGray = createIconComponent(playersIconGray);
export const PlayersIconBlack = createIconComponent(playersIconBlack);